<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_1"></a><i>To the memory of lucy Hollembeak</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_dedication1.vue?25acb6ae